import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { getTheme, noSelect } from 'helpers'
import styled from 'styled-components'
import svgLoading from 'assets/svg/icon-loading.svg'
export const FormGroup = styled.div`
  margin-bottom: 10px;
`

export const Label = styled.div`
  display: block;
  font-weight: 500;
  font-size: 18px;
  line-height: 30px;
  margin-bottom: 5px;
  ${props => props.required ? `
    &:after {
      content: '*';
    }
  ` : ''}
`
export const Input = styled.input`
  width: calc(100% - 2px);
  height: 45px;
  margin: 0px;
  padding: 0px;
  background-color: white;
  color: ${getTheme`colorGray`};
  font-size: 24px;
  font-family: ${getTheme`font2`};
  text-indent: 10px;
  border-radius: 5px;
  margin-bottom: 5px;
  &:last-child { margin-bottom: 0px; }
`

export const Select = ({ focused, options, title }) =>
  <SelectWrapper>
    <Title>{title}</Title>
    <Caret focused={focused} src='/images/icon-down-tiffany.png' />
    <Options>
      {(options || []).map(({ key, title }) => <Option>{title}</Option>)}
    </Options>
  </SelectWrapper>

const SelectWrapper = styled.div`
  position: relative;
  width: calc(100% - 2px);
  height: 45px;
  margin: 0px;
  padding: 0px;
  background-color: white;
  color: ${getTheme`colorGray`};
  font-size: 24px;
  font-family: ${getTheme`font2`};
  text-indent: 10px;
  border-radius: 5px;
  border: 1px solid ${getTheme`colorBorder`};
  margin-bottom: 5px;
  &:last-child { margin-bottom: 0px; }
`
const Title = styled.div`
  line-height: 45px;
`
const Caret = styled.img`
  position: absolute;
  top: 18px;
  right: 10px;
  width: 16px;
  height: 9px;
  ${noSelect};
  -ms-transform: -ms-transform 0.3s; /* IE 9 */
  -webkit-transition: -webkit-transform 0.3s; /* Safari */
  transition: transform 0.3s;
  ${props => props.focused ? `
    -webkit-transform: rotate(180deg);
    -moz-transform: rotate(180deg);
    -o-transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    transform: rotate(180deg);
  ` : ''}
`
const Options = styled.div`

`
const Option = styled.div``

export class Button extends Component {
  componentDidMount () {
    ReactDOM.findDOMNode(this).addEventListener('touchstart', this._touchStart, false)
    ReactDOM.findDOMNode(this).addEventListener('touchend', this._touchEnd, false)
    ReactDOM.findDOMNode(this).addEventListener('touchcancel', this._touchEnd, false)
  }
  componentWillUnmount () {
    ReactDOM.findDOMNode(this).removeEventListener('touchstart', this._touchStart, false)
    ReactDOM.findDOMNode(this).removeEventListener('touchend', this._touchEnd, false)
    ReactDOM.findDOMNode(this).removeEventListener('touchcancel', this._touchEnd, false)
  }

  _touchStart = () => this.setState({ touched: true })
  _touchEnd = () => this.setState({ touched: false })

  render () {
    const { children, loading, ...rest } = this.props
    return <Btn {...rest}>{loading ? <img alt='' src={svgLoading} /> : children}</Btn>
  }
}

const Btn = styled.div`
  transition: opacity 0.3s ease;
  &:hover { opacity: 0.8; }
  cursor: pointer;
  ${noSelect};
  ${props => props.small ? `
    line-height: 50px;
    height: 50px;
  ` : `
    line-height: 60px;
    height: 60px;
  `}
  max-width: 480px;
  font-size: 18px;
  margin: 0 auto;
  background-color: ${props => props.color ? (props.theme[props.color] || props.color) : props.theme.colorTiffany};
  text-align: center;
  border-radius: 5px;
  color: white;
  > img {
    vertical-align: top;
    ${props => props.small ? `
      margin-top: 15px;
      margin-right: 10px;
      width: 20px;
      height: 20px;
    ` : `
      margin-top: 17px;
      margin-right: 10px;
      width: 26px;
      height: 26px;
    `}
    vertical-align: top;
    filter: brightness(0) invert(1);
  }
`

export const ErrorText = styled.div`
  color: ${getTheme`colorCoral`};
  margin-bottom: 10px;
`



// WEBPACK FOOTER //
// ./src/components/Form.js